module.exports = __webpack_public_path__ + "static/media/parent-pass-logo.3338de21.png";